var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6319 0.916016L24.3272 2.30668L22.424 3.25868V22.6113C22.424 23.4311 21.7894 24.1031 20.9844 24.1622L20.8685 24.1669H3.75736C2.93758 24.1669 2.26558 23.5322 2.20647 22.7272L2.20181 22.6113V13.3698L0.993917 13.9733L0.298584 12.5827L2.20181 11.6315V5.50024H3.75736V10.8537L23.6319 0.916016ZM20.8685 4.03646L3.75736 12.592V22.6113H8.42403V14.8336C8.42403 14.0138 9.05869 13.3418 9.8637 13.2819L9.97958 13.278H14.6462C15.466 13.278 16.138 13.9127 16.1979 14.7177L16.2018 14.8336V22.6113H20.8685V4.03646ZM14.6462 14.8336H9.97958V22.6113H14.6462V14.8336ZM18.5351 8.61135C18.9645 8.61135 19.3129 8.95979 19.3129 9.38913C19.3129 9.81846 18.9645 10.1669 18.5351 10.1669C18.1058 10.1669 17.7574 9.81846 17.7574 9.38913C17.7574 8.95979 18.1058 8.61135 18.5351 8.61135Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.26d958615d21acfe2d18d32bb294a255.svg";
export { ForwardRef as ReactComponent };